import SingleSelectPage from "@components/SingleSelectPage"

const OPTIONS = [
  "textDescription",
  "photoOfFood",
  "voiceMessages",
  "mixOfEverything",
] as const

export default function MessagingStyle() {
  return <SingleSelectPage translationKey="messagingStyle" options={OPTIONS} />
}
